
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import SpecialsScreen from './specials';
import { useRefresh } from '../../hooks/useRefresh';
import ListProducts from './ListProducts';
import Bottles from './bottles';
import Shots from './shots';


function Index({setShowHappy}) { 
     const {change} = useRefresh();
    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

    const [showSpecials, setShowSpecials] = useState(false);
    const [showBottles, setshowBottles] = useState(false);
     const [menus, setMenus] = useState([]);
    const [dishs, setdishs] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showshots, showsetshots] = useState(false);
    
    const [coctaiks, setcoctaiks] = useState(false);
    const [canta, setcanta] = useState(false);
    const [house, sethouse] = useState  (false);
    const [dataBottles, setdataBottles] = useState(false);
    const [paracetamor, setparacetamor] = useState(false);
     const [beers, setbeers] = useState(false);

     const [mini, setmini] = useState(false);
     useEffect(() => {
            getData('menu').then((items) => {
                const data = items.value.data;
               
                setMenus(data);
            });
        }, [change]);
    
    
          useEffect(() => {
                menus.map((item) => {
                     if (item.id === 494) {
                            setcoctaiks(item);
                     }
                     if (item.id === 534) {
                        setcanta(item);
                     }
                    if (item.id === 496) {
                        setdataBottles(item);
                    }
                    if (item.id === 539) {
                        sethouse(item);
                    }
                    if (item.id === 493) {
                        setparacetamor(item);
                    }
                    if (item.id === 500) {
                        setbeers(item);
                    }
                    if (item.id === 540) {
                        setmini(item);
                    }
                });
          }, [menus]);
    
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowSpecials={setShowSpecials} setShowListProduct={setShowHappy}>
                <div  style={{padding: '0 20px'}}>
                     
                    <div
                        style={{
                        justifyContent: 'center',
                            alignItems: 'center',
                            marginTop: -20,
                            position: 'relative',
                      
                        }}>
                        <p
                        style={{
                            fontFamily: 'Roadstore',
                            color: '#B20B0A',
                                fontSize: 90,
                                position: 'relative',
                            zIndex: 100
                        }}>
                        drinks
                        </p>

                         <img
                                src={require('./assets/ITEM.png')}
                            style={{
                                    position: "absolute",
                                width: '100%',
                                top: -30,
                                right: -160,
                                    
                                    height: 150,
                                objectFit: 'contain',
                                    zIndex: 1
                                }}
                                />
                    </div>
                    

                    <div>
                        <div
                            style={{display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                gap: 20,
                            }}>
                            <div
                                onClick={() => {
                                    setdishs(coctaiks)
                                    setShowListProduct(true)
                                }
                                }
                                style={{
                                width: 400,
                                justifyContent: 'center',
                                borderRadius: 14,
                                marginTop: 20,
                                }}>
                                <img
                                src={require('./assets/item2.png')}
                                style={{
                                    width: '100%',
                                    height: 150,
                                    objectFit: 'contain',
                                    marginLeft: 9,
                                }}
                                />
                            </div>
                            <div
                                onClick={() => {
                                    setdishs(canta)
                                    setShowListProduct(true)
                                }}
                                style={{
                                width: 400,
                                justifyContent: 'center',
                                borderRadius: 14,
                                }}>
                                <img
                                src={require('./assets/item1.png')}
                                style={{
                                    width: '100%',
                                    height: 170,
                                    objectFit: 'contain',
                                }}
                                />
                            </div>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: 'row',
                                alignItems: 'center',
                                gap: 20,
                                marginTop: 10,
                            }}>
                            {/* <div
                                onClick={() => {
                                    setdishs(house)
                                    setShowListProduct(true)
                                }}
                                style={{
                                width: 400,
                                justifyContent: 'center',
                                borderRadius: 14,
                                }}>
                                <img
                                src={require('./assets/house.png')}
                                style={{
                                    width: '100%',
                                    height: 150,
                                    objectFit: 'contain',
                                }}
                                />
                            </div> */}
                            <div
                                onClick={() =>
                                {
                                    setshowBottles(true)
                               }
                                }
                                style={{
                                width: 400,
                                justifyContent: 'center',
                                borderRadius: 14,
                                marginTop: 20,
                                }}>
                                <img
                                src={require('./assets/bottles.png')}
                                style={{
                                    width: '100%',
                                    height:150,
                                    marginLeft: 5,
                                    objectFit: 'contain',
                                }}
                                />
                            </div>
                             <div
                                onClick={() => {
                                    setdishs(mini)
                                    setShowListProduct(true)
                                    // navigation.navigate('MenuList', {categorie: mini})
                                }
                               
                                }
                                style={{
                                width: 340,
                                justifyContent: 'center',
                                    borderRadius: 14,
                                marginTop:10
                                }}>
                                <img
                                src={require('./assets/mini.png')}
                                style={{
                                    width: '100%',
                                    height: 160,
                                    objectFit: 'contain',
                                }}
                                />
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                marginTop: 5,
                                gap: 20,
                                zIndex: 9999,
                            }}>
                            <div
                                onClick={() =>
                                {
                                    showsetshots(true)
                                }
                                }
                                style={{
                                width: 400,
                                marginTop: 18,
                                justifyContent: 'center',
                                borderRadius: 14,
                                }}>
                                <img
                                src={require('./assets/shots.png')}
                                style={{
                                    width: '100%',
                                    height: 140,
                                    objectFit: 'contain',
                                }}
                                />
                            </div>

                            <div
                                onClick={() => {
                                   setdishs(beers)
                                    setShowListProduct(true)
                                }}
                                style={{
                                width: 400,
                                justifyContent: 'center',
                                borderRadius: 14,
                                }}>
                                <img
                                src={require('./assets/beers.png')}
                                style={{
                                    width: '100%',
                                    height: 145,
                                    objectFit: 'contain',
                                }}
                                />
                            </div>
                        </div>

                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent:"center",
                                marginTop: 5,
                                gap: 20,
                                zIndex: 9999,
                            }}>
                           
                            <div
                                onClick={() => {
                                    setdishs(paracetamor)
                                    setShowListProduct(true)
                                }
                               
                                }
                                style={{
                                width: 400,
                                justifyContent: 'center',
                                borderRadius: 14,
                                marginTop: 10,
                                }}>
                                <img
                                src={require('./assets/item6.png')}
                                style={{
                                    width: '100%',
                                    height: 150,
                                    objectFit: 'contain',
                                }}
                                />
                            </div>
                        </div>
                    </div>
                   
                </div>
                
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowHappy} />}
                {showBottles && <Bottles setShowListProduct={setShowSpecials} setShowHappy={setshowBottles} />}
                 {showshots && <Shots setShowListProduct={setShowSpecials} setShowHappy={showsetshots} />}
                
                {showListProduct && <ListProducts
                        dishs={dishs}
                        setShowListProduct={setShowListProduct}
                    />}
            </LayoutContent>
        </div>
    );
}
export default Index;